import getLocal from '@/app/utils/getLocal';
import { EfModal } from '@/components/UI';
import { copyText } from '@/utils';
import EditorLink from 'lowcode/components/EditorLink';
import { getLang } from 'lowcomp/plugins/member/utils';
import { FC, useState } from 'react';
import { TextLang } from '../TextLang';
import BenefitsMessage from './BenefitsMessage';
import BenefitsTable from './BenefitsTable';
import { IActive, useTableList } from './config';
import styled from './index.module.scss';
// import { useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';

interface IPorps {
    isLogin: boolean;
}

const Benefits: FC<IPorps> = ({ isLogin }) => {
    const { locale } = getLocal();
    const t = getLang(TextLang, locale);
    const [active, setActive] = useState<IActive>('savings');
    const tableList = useTableList(active, locale, t);
    const [harvestOpen, setHarvestOpen] = useState(false);
    const [harvestOpenNext, setHarvestOpenNext] = useState(false);

    const tabs: { key: IActive; text: string }[] = [
        {
            key: 'savings',
            text: t('ecoflowbenefits_savings'),
        },
        {
            key: 'support',
            text: t('ecoflowbenefits_support'),
        },
        {
            key: 'experiences',
            text: t('ecoflowbenefits_experiences'),
        },
    ];

    // 根据不同的key 处理不同的逻辑
    const handleTools = (key?: string) => {
        if (key === 'referral') {
            // window.open(`https://www.ecoflow.com/${locale}/referral`, '_blank');
            window.open(`${window.location.origin}/${locale}/referral`, '_blank');
        }
        // 这两个都是na独有的弹窗
        if (key === 'getCode1') {
            copyText('ECOFLOWHH25');
            setHarvestOpen(true);
        }
        if (key === 'getCode2') {
            copyText('EcoFlow10');
            setHarvestOpenNext(true);
        }
    };

    return (
        <>
            <div
                className={`main-page ${styled.Benefits} GtmModuleData-section`}
                data-section-id={'Member-Benefits'}
                data-section-title={t('ecoflowbenefits_title')}
                id="ECO_BENEFITS"
            >
                <div className="wtep-wrapper">
                    <h5 className="ecocredits-title">{t('ecoflowbenefits_title')}</h5>
                    <ul className="benefits-tabs">
                        {tabs.map((item) => (
                            <li key={item.key} className={item.key === active ? 'active' : ''} onClick={() => setActive(item.key)}>
                                <span>{item.text}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="benefits-table-box">
                        <BenefitsTable list={tableList} handleTools={handleTools} isLogin={isLogin} />
                    </div>
                    {locale !== 'jp' && <BenefitsMessage active={active} />}
                </div>
            </div>
            {/* 之前的弹窗 */}
            <EfModal className={styled.efmodal} visible={harvestOpen} onCancel={() => setHarvestOpen(false)} zIndex={1200}>
                <div className="content">
                    <h5 className="m-title">PARTNERS BENEFITS</h5>
                    <h5 className="m-subtitle">Code Copied !</h5>
                    <p className="m-desc">
                        EcoFlow members can save 25% off the first year of a Harvest Hosts annual membership using the code &apos;ECOFLOWHH25&apos; at signup.
                    </p>
                    <p className="m-code">code：ECOFLOWHH25</p>
                    <EditorLink
                        className="m-btn"
                        href="https://harvesthosts.com/join-now/?utm_source=HHM-Ecoflow-MemDayPromo-2023&utm_medium=referral&utm_campaign=HHM-Ecoflow-MemDayPromo-2023&utm_content=ECOFLOWHH25&a=0"
                    >
                        Go to Harvest Hosts
                    </EditorLink>
                </div>
            </EfModal>
            <EfModal className={styled.efmodal} visible={harvestOpenNext} onCancel={() => setHarvestOpenNext(false)} zIndex={1200}>
                <div className="content">
                    <h5 className="m-title">PARTNERS BENEFITS</h5>
                    <h5 className="m-subtitle">Code Copied !</h5>
                    <p className="m-desc">EcoFlow members can save 10% off of all Winnebago Gear, discovering RV lifestyle with Winnebago.</p>
                    <p className="m-code">code：EcoFlow10</p>
                    <EditorLink className="m-btn" href="https://www.winnebagooutdoor.com/">
                        Go to Winnebago Gear
                    </EditorLink>
                </div>
            </EfModal>
        </>
    );
};

export default Benefits;
